module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-Regular.60202546.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/PlayfairDisplay-Regular.ttf
// module id = 36
// module chunks = 0